import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {ThresholdRewardFormComponent} from '@app/main/content/general-settings/threshold-reward/threshold-reward-form/threshold-reward-form.component';

@Component({
  selector: 'threshold-reward',
  templateUrl: './threshold-reward.component.html',
  styleUrls: ['./threshold-reward.component.scss']
})
export class ThresholdRewardComponent implements OnInit {
  fileNameDialogRef: any;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit() {
  }

  openDialog() {
    this.fileNameDialogRef = this.dialog.open(ThresholdRewardFormComponent, {
      panelClass: 'threshold-reward-form-dialog',
      data: {
        action: 'new'
      }
    });

    this.fileNameDialogRef
      .afterClosed()
      .subscribe((response: FormGroup) => {
        if (!response) {
          return;
        }
      });
  }

}
